'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGoat = function MdGoat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.9 15.2c0.1 0 0.1 0.3 0 0.3l-1.9 2.5c-0.1 0.1-0.3 0.2-0.3 0.2l-1.2-0.2-0.6 1.7c-0.2 0.4-0.7 0.4-1 0l-1.1-2.4-1.8-0.3-3.6 8.7 1.3 10.6c0 0.3-0.2 0.3-0.3 0.3h-1.6c-0.1 0-0.2 0-0.3-0.2l-1.6-6.3-0.7-1.3-2 7.6c0 0.2-0.2 0.2-0.3 0.2h-1.7c-0.1 0-0.3-0.1-0.3-0.3l1.8-10.5h-10.5l-2.8 5.1 0.7 5.4c0.1 0.2-0.1 0.3-0.3 0.3h-1.6c-0.1 0-0.2 0-0.3-0.1l-2.2-8-2.7 3.1 0.5 4.7c0.1 0.2-0.1 0.3-0.3 0.3h-1.7c-0.2 0-0.3 0-0.3-0.1l-1.1-4.4 1.7-6.4v-11.2s-1.8-0.7-1.8-2.4h21.4s3.7 0.1 7.4-2.6c0 0-0.6-1.7 0.5-2.8 0 0 2.2 1.6 2.8 2 0.8 0.4 1.3-0.4 1.1-1.1-0.2-0.5-0.7-2.2-3.5-3.3-0.4-0.1-1.2-0.2-1-0.7 0-0.2 0.1-0.2 0.3-0.2 3.4 0.4 5.4 3.2 6 4.5 0.1 0.1 1.6 1.2 1.4 3 0 0.2 0 0.3 0.2 0.5z' })
        )
    );
};

exports.default = MdGoat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/goat.js
// module id = 1524
// module chunks = 168707334958949